module.exports = __webpack_public_path__ + "static/media/icon-comparison-left.d939312d.png";